import React, { useEffect, useRef } from "react";

import { userCheckComplete, userLoading, userSuccess } from "../store/modules/auth/authStateActions";
import { persistor } from "../store/store";
export default function AuthProvider({ userManager: manager, store, children }) {
  let userManager = useRef();
  const hasBootstrapped = useRef(false);

  // On first mount (e.g. a freshly opened tab) check for a session the oidc-client user store
  // already knows about before routing can decide the user is logged out - oidc-client's own
  // store is shared across tabs (localStorage), unlike the redux-persisted auth state (sessionStorage).
  useEffect(() => {
    if (hasBootstrapped.current) return;
    hasBootstrapped.current = true;

    store.dispatch(userLoading());
    manager
      .getUser()
      .then((user) => {
        if (user && !user.expired) {
          store.dispatch(userSuccess(user));
        } else {
          store.dispatch(userCheckComplete());
        }
      })
      .catch((error) => {
        console.log("[oidc] initial user check error", error.message);
        store.dispatch(userCheckComplete());
      });
  }, [manager, store]);

  useEffect(() => {
    userManager.current = manager;

    const onUserLoaded = (user) => {
      store.dispatch(userSuccess(user));
    };

    const onUserUnloaded = async () => {
      await persistor.purge();
    };

    const onAccessTokenExpiring = () => {};

    const onAccessTokenExpired = async () => {
      await persistor.purge();
    };

    const onUserSignedOut = async () => {
      await persistor.purge();
    };

    // events for user
    userManager.current.events.addUserLoaded(onUserLoaded);
    userManager.current.events.addUserUnloaded(onUserUnloaded);
    userManager.current.events.addAccessTokenExpiring(onAccessTokenExpiring);
    userManager.current.events.addAccessTokenExpired(onAccessTokenExpired);
    userManager.current.events.addUserSignedOut(onUserSignedOut);

    userManager.current.events.addSilentRenewError((e) => {
      console.log("[oidc] silent renew error", e.message);
    });

    // Specify how to clean up after this effect:
    return function cleanup() {
      userManager.current.events.removeUserLoaded(onUserLoaded);
      userManager.current.events.removeUserUnloaded(onUserUnloaded);
      userManager.current.events.removeAccessTokenExpiring(onAccessTokenExpiring);
      userManager.current.events.removeAccessTokenExpired(onAccessTokenExpired);
      userManager.current.events.removeUserSignedOut(onUserSignedOut);
    };
  });

  return React.Children.only(children);
}
